import { render } from "./CitesInfoComponent.vue?vue&type=template&id=0ab6c45e&ts=true"
import script from "./CitesInfoComponent.vue?vue&type=script&lang=ts"
export * from "./CitesInfoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__